import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

interface Props {
  top?: number;
  left?: number;
  width?: number;
  height?: number;
}

const DescriptionMaskLateral = styled.div<Props>`
  background: linear-gradient(88deg, #0f0f0f 1.48%, rgba(15, 15, 15, 0) 71.68%);
  position: absolute;
  width: ${(props) => (props.width || 227) * Screen.widthRatio}px;
  height: ${(props) => (props.height || 576) * Screen.widthRatio}px;
  left: ${(props) => (props.left || 880) * Screen.widthRatio}px;
  top: ${(props) => (props.top || 0) * Screen.widthRatio}px;
`;

export default DescriptionMaskLateral;
